import React, { useEffect } from 'react'
import { createSelector } from 'reselect';
import checkPermission from '../../Components/Hooks/PermissionHook';
import { Navigate } from 'react-router-dom';
import { setBreadcrumb } from '../../slices/auth/menu/reducer';
import { useDispatch, useSelector } from 'react-redux';
import { Card, Col, Container, Row } from 'reactstrap';
import Search from './Search';
import Widget from './Widget';
import Preloader from '../../Components/Common/Preloader';
import ChildTable from './ChildTable';
import UsersByDevice from './ImpressionByDevice';
import ImpressionByDevice from './ImpressionByDevice';
import ClickByDevice from './ClickByDevice';
import Location from './Location';
import StatisticsChart from './StatisticsChart';
import { getStatistics, setAnalyticsCampaigns, setAnalyticsPreloader, setChildTableData, setClick, setClickByDeviceData, setEndDate, setImpression, setImpressionByDeviceData, setInfoContLoader, setLocationData, setStartDate, setStatisticsChartData } from '../../slices/analytics/reducer';
import { replace } from 'redux-first-history';
import DetailCard from './DetailCard';
import CreativesList from './CreativesList';
import CreativeModal from './CreativeModal';

function Analytics() {
  const dispatch = useDispatch();
  document.title = 'Analytics | Adcropper';

  const selectState = createSelector(state => state, state => ({
    analyticsCampaigns: state.Analytics.analyticsCampaigns,
    analyticsPreloader: state.Analytics.analyticsPreloader,
    startDate: state.Analytics.startDate,
    endDate: state.Analytics.endDate,
    infoContLoader: state.Analytics.infoContLoader,
    impression: state.Analytics.impression,
    click: state.Analytics.click,
    childTableData: state.Analytics.childTableData,
    impressionByDeviceData: state.Analytics.impressionByDeviceData,
    clickByDeviceData: state.Analytics.clickByDeviceData,
    locationData: state.Analytics.locationData,
    statisticsChartData: state.Analytics.statisticsChartData,
    previousLocations: state.router.previousLocations,
    getImpressionByDevice: state.Analytics.getImpressionByDevice,
    getLocation: state.Analytics.getLocation,
    getClickByDevice: state.Analytics.getClickByDevice,
    getStatistics: state.Analytics.getStatistics,
  }));

  const { analyticsCampaigns,
    analyticsPreloader,
    startDate,
    endDate,
    infoContLoader,
    impression,
    click,
    childTableData,
    impressionByDeviceData,
    clickByDeviceData,
    locationData,
    statisticsChartData,
    previousLocations,
    getImpressionByDevice,
    getLocation,
    getClickByDevice,
    getStatistics } = useSelector(selectState);

  useEffect(() => {
    dispatch(setBreadcrumb({ pageTitle: 'Analytics', title: [{name: 'Analytics', src:window.location.href}] }));
  }, [])

  // if (
  //   checkPermission('companies', null, 'campaignAnalyze') ||
  //   checkPermission('clients', null, 'campaignAnalyze') ||
  //   checkPermission('brands', null, 'campaignAnalyze') ||
  //   checkPermission('markets', null, 'campaignAnalyze')
  // ) {
    return (
      <React.Fragment>
        {analyticsPreloader ?
          <Preloader />
          : null}
        <Container fluid>
          <Row>
            <Col lg={12} md={12} sm={12}>
              <Search />
            </Col>
          </Row>
          <Row>
            <Col lg={8} md={12}>
              <Row>
                <Col xxl={4} xl={12} lg={12} md={12}>
                  <Widget avatarColorClass={'bg-primary'}
                    avatarIcon={'ri-eye-line text-white fs-3'}
                    text={''}
                    header={'IMPRESSIONS'}
                    start={0}
                    prefix={''}
                    suffix={''}
                    separator={','}
                    end={impression?.current}
                    decimals={0}
                    duration={4}
                  />
                </Col>
                <Col xxl={4} xl={12} lg={12} md={12}>
                  <Widget avatarColorClass={'bg-warning'}
                    avatarIcon={'mdi mdi-cursor-default-outline text-primary fs-19'}
                    text={''}
                    header={'CLICKS'}
                    start={0}
                    prefix={''}
                    suffix={''}
                    separator={','}
                    end={click?.current}
                    decimals={0}
                    duration={4} />
                </Col>
                <Col xxl={4} xl={12} lg={12} md={12}>
                  <Widget avatarColorClass={'bg-info'}
                    avatarIcon={'ri-percent-line fs-3'}
                    text={''}
                    header={'CLICK RATE'}
                    start={0}
                    prefix={''}
                    suffix={'%'}
                    separator={','}
                    end={((click?.current / impression?.current) * 100)}
                    decimals={2}
                    duration={4} />
                </Col>
              </Row>
              <Row>
                <Col lg={12} md={12} sm={12} className='h-100'>
                  <StatisticsChart />
                </Col>
              </Row>
            </Col>
            <Col lg={4} md={12}>
              <ChildTable />
            </Col>
          </Row>
          <Row>
            <Col lg={4} md={12} sm={12}>
              <ClickByDevice />
            </Col>
            <Col lg={4} md={12} sm={12}>
              <ImpressionByDevice />
            </Col>
            <Col lg={4} md={12} sm={12}>
              <Location />
            </Col>
          </Row>
          <Row>
            <Col lg={12} md={12} sm={12}>
              <CreativeModal />
              <CreativesList />
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    )
  // } else {
  //   return (
  //     <Navigate to={'/out-of-permission'} />
  //   )
  // }

}

export default Analytics
